import {
    GET_EMAIL_TEMPLATE_REQUEST, GET_EMAIL_TEMPLATE_SUCCESS, GET_EMAIL_TEMPLATE_FAIL,
    UPSERT_EMAIL_TEMPLATE_REQUEST, UPSERT_EMAIL_TEMPLATE_SUCCESS, UPSERT_EMAIL_TEMPLATE_FAIL,
    DELETE_EMAIL_TEMPLATE_REQUEST, DELETE_EMAIL_TEMPLATE_SUCCESS, DELETE_EMAIL_TEMPLATE_FAIL,
    TOGGLE_REPORT_EMAIL_REQUEST, TOGGLE_REPORT_EMAIL_SUCCESS, TOGGLE_REPORT_EMAIL_FAIL
} from "../constant";

const initialState = {
    loading: false,
    saving: false,
    toggling: false,
    templateData: null,
};

const emailTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMAIL_TEMPLATE_REQUEST:
            return { ...state, loading: true };
        case GET_EMAIL_TEMPLATE_SUCCESS:
            return { ...state, loading: false, templateData: action.payload };
        case GET_EMAIL_TEMPLATE_FAIL:
            return { ...state, loading: false, templateData: null };

        case UPSERT_EMAIL_TEMPLATE_REQUEST:
            return { ...state, saving: true };
        case UPSERT_EMAIL_TEMPLATE_SUCCESS:
            return { ...state, saving: false, templateData: { ...state.templateData, ...action.payload } };
        case UPSERT_EMAIL_TEMPLATE_FAIL:
            return { ...state, saving: false };

        case DELETE_EMAIL_TEMPLATE_REQUEST:
            return { ...state, saving: true };
        case DELETE_EMAIL_TEMPLATE_SUCCESS:
            return { ...state, saving: false, templateData: null };
        case DELETE_EMAIL_TEMPLATE_FAIL:
            return { ...state, saving: false };

        case TOGGLE_REPORT_EMAIL_REQUEST:
            return { ...state, toggling: true };
        case TOGGLE_REPORT_EMAIL_SUCCESS:
            return { ...state, toggling: false, templateData: { ...state.templateData, email_enabled: action.payload } };
        case TOGGLE_REPORT_EMAIL_FAIL:
            return { ...state, toggling: false };

        default:
            return state;
    }
};

export { emailTemplateReducer };
